import { render, staticRenderFns } from "./VxCard.vue?vue&type=template&id=78fc882a"
import script from "./VxCard.vue?vue&type=script&lang=js"
export * from "./VxCard.vue?vue&type=script&lang=js"
import style0 from "./VxCard.vue?vue&type=style&index=0&id=78fc882a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports